import React from 'react';

const SimpleFooter = ({ footerLanguage }) => (
  <div className="border-t border-border bg-card px-6 py-4 print:hidden">
    <p className="text-center text-xs text-muted-foreground">{footerLanguage}</p>
  </div>
);

export default SimpleFooter;
